import { React, useState } from "react";
import bggenai from "../../assets/bggenai.png";
import bgsd from "../../assets/bgsd.png";
import Logo from "../../assets/Logo.svg";
import { Box, Typography } from "@mui/material";
import { AiOutlineFileText, AiOutlineFilePdf } from "react-icons/ai"; // Sample icons
import CM from "../../assets/CM.png";
import CPO from "../../assets/CPO.png";
import { Radio, RadioButtonChecked } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Personas = ({ selectedFile }) => {
  const navigate = useNavigate();
  const [selectedBox, setSelectedBox] = useState(null);
  const [hoveredBox, setHoveredBox] = useState(null);

  const uploadBoxes = [
    {
      id: 1,
      icon: CPO,
      label: "Chief Procurement Officer",
      description: "Supported formats: .txt, .docx",
    },
    {
      id: 2,
      icon: CM,
      label: "Category Manager",
      description: "Supported formats: .pdf",
    },
    // Add more configurations here as needed
  ];
  return (
    <Box
      sx={{
        display: "flex",
        backgroundImage: `url(${bgsd})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {/* Logo */}
      <Box sx={{ marginBottom: "20px" }}>
        <img src={Logo} alt="Logo" style={{ width: "200px" }} />
      </Box>

      {/* Centered Step Box */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF0F",
          border: "1px solid #FFFFFF1A",
          borderRadius: "16px",
          padding: "24px",
          width: "100%",
          maxWidth: "400px",
          textAlign: "left",
        }}
      >
        <Typography
          sx={{
            color: "#8b8b8b",
            marginBottom: "10px",
            fontSize: "12px",
          }}
        >
          Step 2 of 2
        </Typography>
        <Typography
          //   variant="h5"
          sx={{
            color: "white",
            marginBottom: "5px",
            font: "Inter",
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Choose your role
        </Typography>

        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "12px",
            font: "Inter",
            color: "#FFFFFF99",
            marginBottom: "20px",
          }}
        >
          Select a persona that suits your role at the company the best
        </Typography>

        {/* Upload Box */}
        {/* Dynamically Render Upload Boxes */}
        {uploadBoxes.map((box) => (
          <Box
            key={box.id}
            onClick={() => setSelectedBox(box.id)}
            onMouseEnter={() => setHoveredBox(box.id)}
            onMouseLeave={() => setHoveredBox(null)}
            sx={{
              border: `1px solid ${
                selectedBox === box.id
                  ? "#E193FC"
                  : hoveredBox === box.id && selectedBox !== box.id
                  ? "#E193FC"
                  : "#FFFFFF1F"
              }`,
              borderRadius: "12px",
              padding: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              position: "relative", // Add this for proper checkmark positioning
              justifyContent: "left",
              marginBottom: "10px",
              cursor: "pointer",
              width: "352px",
              height: "72px",
            }}
          >
            <img
              src={box.icon}
              alt="Logo"
              style={{ width: "40px", height: "40px", marginRight: "8px" }}
            />
            <Typography
              sx={{
                color: "#FFFFFFE5",
                fontSize: "16px",
                fontWeight: 600,
                font: "Inter",
                textAlign: "center",
                gap: "4px",
              }}
            >
              {box.label}
            </Typography>
            {selectedBox === box.id && (
              <RadioButtonChecked
                checked={true}
                sx={{
                  position: "absolute",
                  right: 20,
                  color: "#E193FC", // unchecked color
                  "&.Mui-checked": {
                    color: "#E193FC", // checked color
                  },
                }}
              />
            )}
          </Box>
        ))}
        {/* Confirm Button */}
        {selectedBox && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Box
              component="button"
              sx={{
                background: "linear-gradient(180deg, #BF6FE5 0%, #CA698F 100%)",
                color: "#000000",
                border: "none",
                borderRadius: "8px",
                padding: "10px",
                fontSize: "16px",
                fontWeight: 600,
                cursor: "pointer",
                width: "352px",
                height: "48px",
                color: "#FFFFFF",
                font: "Inter",
                fontWeight: 600,
                fontSize: "14px",
                // '&:hover': {
                //   backgroundColor: '#d17ee8',
                // },
              }}
              onClick={() => ({
                state: {
                  roleTitle: uploadBoxes.find((box) => box.id === selectedBox)
                    ?.label,
                },
              })}
            >
              Confirm
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Personas;
